export default {"src":"/_next/static/media/parachute-man.f79b9561.svg","height":354,"width":239};